import { render } from "./LayoutInfo.vue?vue&type=template&id=3d056f63&scoped=true"
import script from "./LayoutInfo.vue?vue&type=script&lang=js"
export * from "./LayoutInfo.vue?vue&type=script&lang=js"

import "./LayoutInfo.vue?vue&type=style&index=0&id=3d056f63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d056f63"]])

export default __exports__